import {
  CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_BEGIN,
  CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_SUCCESS,
  CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_FAILURE,
  CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCustomDataMapping(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-data-mapping`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomDataMappingError() {
  return {
    type: CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_BEGIN:
      return {
        ...state,
        loadCustomDataMappingPending: true,
        loadCustomDataMappingError: null,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_SUCCESS:
      return {
        ...state,
        loadCustomDataMappingPending: false,
        loadCustomDataMappingError: null,
        customDataMappings: action.data,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_FAILURE:
      return {
        ...state,
        loadCustomDataMappingPending: false,
        loadCustomDataMappingError: action.data.error,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR:
      return {
        ...state,
        loadCustomDataMappingError: null,
      };

    default:
      return state;
  }
}
